import { application } from "./application"

import AccessController from "./access_controller"
import AutosubmitController from "./autosubmit_controller"
import ClipboardController from "./clipboard_controller"
import FileViewerController from "./file_viewer_controller"
import PageRefreshController from "./page_refresh_controller"
import PasskeyController from "./passkey_controller"
import ReadGateController from "./read_gate_controller"
import RefreshController from "./refresh_controller"
import RevealController from "./reveal_controller"
import SelectionController from "./selection_controller"
import TilesController from "./tiles_controller"

application.register("access", AccessController)
application.register("autosubmit", AutosubmitController)
application.register("clipboard", ClipboardController)
application.register("file-viewer", FileViewerController)
application.register("page-refresh", PageRefreshController)
application.register("passkey", PasskeyController)
application.register("read-gate", ReadGateController)
application.register("refresh", RefreshController)
application.register("reveal", RevealController)
application.register("selection", SelectionController)
application.register("tiles", TilesController)
